module.exports = __webpack_public_path__ + "img/frogigo_logo1.98235ea3.png";